<template>
  <v-sheet
    max-width="380"
    class="mx-auto"
    color="transparent"
  >
    <v-form
      @submit.prevent="$v.$invalid ? null : submit()"
      ref="form"
      class="my-10"
    >
      <v-text-field
        :error-messages="fieldErrors('password').length>0?$t(page+'.'+fieldErrors('password')):null"
        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPwd ? 'text' : 'password'"
        @input="$v.password.$touch()"
        @blur="$v.password.$touch()"
        @focus="message='';password=null,repeatPassword=null"
        prepend-inner-icon="lock"
        v-model="password"
        label="Password"
        @click:append="showPwd = !showPwd"
        outlined
        color="info"
      />
      <v-text-field
        type="password"
        :label="$t(page+'.Confirm Password')"
        v-model="repeatPassword"
        :error-messages="fieldErrors('repeatPassword').length>0?$t(page+'.'+fieldErrors('repeatPassword')):null"
        @input="$v.repeatPassword.$touch()"
        @blur="$v.repeatPassword.$touch()"
        prepend-inner-icon="enhanced_encryption"
        required
        outlined
        color="info"
      ></v-text-field>

      <v-btn
        block
        color= "info"
        type="submit"
        :disabled="$v.$invalid"
        :loading="loader"
      >{{$t(page+'.Reset Password')}}</v-btn>
    </v-form>
    <v-alert
      v-if="message"
      type="error"
      dark
      dense
      dismissible
      class="mt-4"
    >
      {{message}}
    </v-alert>
  </v-sheet>
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
export default {
  mixins: [validationMixin],
  validations: {
    password: { required },
    repeatPassword: {
      sameAsPassword: sameAs("password")
    }
  },
  validationMessages: {
    password: { required: 'Password is required field.' },
    repeatPassword: {
      sameAsPassword: 'Needs to match with Password'
    }
  },
  created(){
    const la=window.navigator.userLanguage||window.navigator.language;
    this.$store.dispatch("setLocale",la.substring(0,2));
  },  
  data () {
    return {
      page:'Auth',
      errors: null,
      password: null,
      repeatPassword: null,
      loader: false,
      showPwd: false,
      message:'',
    };
  },
  methods: {
      async submit() {
        this.loader=true;
        try{
          let hash=sessionStorage.getItem('hash');
          const res = await this.$http.post('/auth/resetpassword.php', {"password":this.password,"repeatpassword":this.repeatPassword,"hash":hash})    
          if (res.data.errorid=='0'){
            sessionStorage.setItem('jwt', res.data.jwt);
            sessionStorage.setItem('hash', res.data.hash);
            this.$emit("complete", true);
            this.message=res.data.message;
          }
          else
          {
            this.message=res.data.message;
          }
      } catch(e)
      {
        let user2='{"errorid":"0005","message":"Email non censita","level":"6","active":"1","company":"xLogistics","email":"mail@jslab.it","landingpage":"dashboard","avatar":"/static/avatar/nir.jpg","subscriptionlevel":"0","subscriptionexpiry":"2021-01-31 00:00:00.000","credits":".0000","name":"Nir Erlich","currency":"ils","locale":"he"}';
        let user3=JSON.parse(user2);
        this.message=user3.message;
      }
      this.loader=false;
    },
    /*
    submit () {
      this.loader = true;
      setTimeout(() => {
        this.loader = false;
        this.$emit("complete", true);
      }, 2000);
    },*/
  },
};
</script>
